import PropTypes from 'prop-types';
import AddressPropType from './AddressPropType';
import EmailPropType from './EmailPropType';
import PhonePropType from './PhonePropType';
import SocialPropType from './SocialPropType';

const DonorWorkPropType = {
  addresses: PropTypes.arrayOf(PropTypes.shape(AddressPropType)),
  avatar: PropTypes.string,
  created: PropTypes.string,
  deleted: PropTypes.bool,
  description: PropTypes.string,
  emails: PropTypes.arrayOf(PropTypes.shape(EmailPropType)),
  industry: PropTypes.string,
  label: PropTypes.string,
  orgName: PropTypes.string,
  ownerOrgId: PropTypes.string,
  phones: PropTypes.arrayOf(PropTypes.shape(PhonePropType)),
  roles: PropTypes.arrayOf(
    PropTypes.shape({
      orgId: PropTypes.string,
      dateFrom: PropTypes.string,
      jobTitle: PropTypes.string,
      jobDescription: PropTypes.string,
      managerName: PropTypes.string,
    }),
  ),
  updated: PropTypes.string,
  website: PropTypes.string,
  workId: PropTypes.string,
  ...SocialPropType,
};

export default DonorWorkPropType;
